import { useRequest } from "@certn/api";
import {
  BasicButton,
  DialogFooter,
  Modal,
  PrimaryButton,
  Text,
} from "@certn/cascadia";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  Divider,
} from "@certn/cascadia-react";
import { EVENT_NAMES, useEventTracking } from "@certn/utils";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { RescreenFrequencyDropdown } from "../../../components/re-screen/RescreenFrequencyDropdown";

interface ScheduleRescreenModalProps {
  isOpen: boolean;
  caseId: string;
  onClose: () => void;
  refreshData: () => void;
}
export function ScheduleRescreenModal({
  onClose,
  isOpen,
  caseId,
  refreshData,
}: ScheduleRescreenModalProps) {
  const { t } = useTranslation();
  const { trackEvent } = useEventTracking();
  const [newRescreenFrequency, setNewRescreenFrequency] = useState<string>("");
  const request = useRequest();

  async function submitEditRescreen(): Promise<void> {
    await request(`/api/internal/client-portal/case/${caseId}/add-rescreen/`, {
      method: "POST",
      body: JSON.stringify({ rescreen: newRescreenFrequency }),
    });
    trackEvent(EVENT_NAMES.CP_SETUP_RESCREEN, {
      rescreenFrequency: newRescreenFrequency,
    });
    refreshData();
    onClose();
  }

  function handleSubmit() {
    submitEditRescreen();
  }

  return (
    <Modal testID="schedule-rescreen-modal" isOpen={isOpen}>
      <Dialog>
        <DialogHeader onClose={onClose}>
          {t("Schedule rescreening")}
        </DialogHeader>
        <DialogContent>
          <Text>
            {t(
              "Ensure ongoing safety and compliance by automatically rescreening applicants. On the scheduled frequency date, the applicant will receive an email to complete another background screening, matching the checks of their initial order. Note, rescreening will be cancelled if the original or previous case was not completed."
            )}
          </Text>
          <div style={{ paddingTop: "var(--space-5)" }}>
            <RescreenFrequencyDropdown
              onChange={(value) => setNewRescreenFrequency(value)}
            />
          </div>
        </DialogContent>
        <Divider />
        <DialogFooter>
          <BasicButton onPress={onClose} testID="close">
            {t("Close")}
          </BasicButton>

          <PrimaryButton onPress={() => handleSubmit()} testID="save">
            {t("Save changes")}
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
